import { useLazyQuery } from '@apollo/client/react';
import { DOG_RESCUE_PAGINATION } from '../../graphql/dog-rescues-queries';

export default function useGetDogRescuesPages() {
    const [getDogRescuesPages, { data, loading }] = useLazyQuery(DOG_RESCUE_PAGINATION);
    return { getDogRescuesPages, data: data?.dogRescues, loading };
}
